// extracted by mini-css-extract-plugin
module.exports = {"scrollArea":"styles_scrollArea__27dI-","gray":"styles_gray__2W8-p","dark":"styles_dark__BAnz1"};